<template>
  <div>
    <v-layout wrap>
      <v-container class="pa-6">
        <canvas id="monitoring-chart"></canvas>
        <br />
        <br />
        <p :key="'list-length-participants-' + entity" v-for="(entity, index) in entities">
          <b>{{entity}}</b>
          : {{entityParticipants[index]}}
          <span
            v-text="parseInt(entityParticipants[index]) > 1 ?'empleados':'empleado'"
          ></span>
        </p>
        <br />
        <br />
        <div :key="'entitie_' + entitie " v-for="entitie in entities">
          <MonitoringChart :entitie="entitie" :areas="areas" :participants="participants_" />
        </div>
        <!-- <pre>
            {{participants_.length}}
            {{entities}}
            {{areas}}
        </pre>-->
      </v-container>
    </v-layout>
    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import MonitoringChart from "@/components/monitoring/MonitoringChart";

import axios from "axios";
import Chart from "chart.js";
export default {
  components: {
    MonitoringChart
  },
  data() {
    return {
      host: process.env.VUE_APP_HOST,
      participants_: [],
      snackbar: false,
      message: "",
      entityData: {},
      entityParticipants: []
    };
  },
  computed: {
    entities() {
      return this.getUniquePersonalDataOptionName("entity", this.participants_);
    },
    areas() {
      return this.getUniquePersonalDataOptionName("area", this.participants_);
    }
  },
  methods: {
    setChart() {
      var entityParticipants = [];
      var colors = [];
      var colorsBorder = [];
      this.entities.forEach(entity => {
        colors.push("#3f51b54a");
        colorsBorder.push("#3f51b5");
        entityParticipants.push(
          (
            (this.participantPersonalDataTypeAndOptionNameFilter(
              "entity",
              entity,
              this.participants_
            ).length /
              this.participants_.length) *
            100
          ).toFixed(2)
        );
        var participants = this.entityParticipants;
        participants.push(
          this.participantPersonalDataTypeAndOptionNameFilter(
            "entity",
            entity,
            this.participants_
          ).length
        );
        this.entityParticipants = participants;
      });

      // console.log(entityParticipants, this.participants_.length);

      var ctx = document.getElementById("monitoring-chart").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: this.entities,
          datasets: [
            {
              label: "Porcentaje de empleados",
              data: entityParticipants,
              backgroundColor: colors,
              borderColor: colorsBorder,
              borderWidth: 1
            }
          ]
        },
        options: {
          scales: {
            xAxes: [
              {
                ticks: {
                  max: 100,
                  beginAtZero: true
                }
              }
            ]
          }
        }
      });
    },
    participantPersonalDataTypeAndOptionNameFilter(
      PersonalDataType,
      PersonalDataOption,
      participants
    ) {
      return participants.filter(participant => {
        if (participant.personalData.entity) {
          return (
            participant.personalData[PersonalDataType].option ==
            PersonalDataOption
          );
        }
        return false;
      });
    },
    getUniquePersonalDataOptionName(value, participants) {
      var withPersonalDataParticipants = participants.filter(participant => {
        return participant.personalData[value];
      });

      var options = withPersonalDataParticipants.map(participant => {
        return participant.personalData[value].option;
      });

      var uniqueOptions = [...new Set(options)];

      return uniqueOptions;
    },
    getParticipants() {
      var vm = this;
      let data = {
        idUser: sessionStorage.getItem("authorization"),
        personalData: true
      };

      axios
        .post(this.host + "/participants/read.php", this.createFormData(data))
        .then(response => {
          vm.participants_ = response.data.data;
        })
        .catch(error => {
          this.snackbar = true;
          this.message = "error";
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  watch: {
    participants_() {
      this.setChart();
    }
  },
  mounted() {
    this.getParticipants();
  }
};
</script>
<style scoped>
.background {
  height: 35vh;
  position: relative;
  z-index: 1;
}
.front {
  position: relative;
  top: -16rem;
  z-index: 10;
}
</style>